import React, { useMemo, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  Button,
} from '@lockerpm/design';

import {
  CheckOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../components/items";
import enterpriseServices from "../../../services/enterprise";
import common from "../../../utils/common";
import global from "../../../config/global";

const JoinEnterprise = (props) => {
  const { t } = useTranslation();
  const { UserInfo } = itemsComponents;

  const {
    enterpriseInvitation,
    callingAPI = false,
    onUnlock = () => {},
  } = props;

  const [loading, setLoading] = useState(false)

  const isAutoApprove = useMemo(() => {
    return enterpriseInvitation?.domain?.auto_approve
  }, [enterpriseInvitation])

  const requested = useMemo(() => {
    return enterpriseInvitation?.status === 'requested'
  }, [enterpriseInvitation])

  const joinEnterprise = async () => {
    setLoading(true);
    enterpriseServices.update_enterprises_invitation(enterpriseInvitation?.id, { status: 'confirmed' }).then(async () => {
      await common.getEnterpriseInvitations();
      await onUnlock();
      setLoading(false);
    }).catch((error) => {
      global.pushError(error);
      setLoading(false);
    })
  }

  return (
    <div className="w-full">
      <div className="text-center">
        <p className="text-2xl font-semibold">
          {t('enterprise.join_organization')}
        </p>
        <p className="mt-2">
          {t('enterprise.join_or_request.desc')}
        </p>
      </div>
      <div className="my-6 flex items-center justify-center">
        <UserInfo />
      </div>
      {
        enterpriseInvitation && <div>
          <p className="mb-4">
            <Trans
              i18nKey={'enterprise.join_or_request.desc_1'}
              values={{ enterpriseName: enterpriseInvitation?.enterprise?.name }}
              components={{
                b: <b className="text-xl font-semibold"/>
              }}
            />
          </p>
          <p>
            {t('enterprise.join_or_request.desc_2', { enterpriseName: enterpriseInvitation?.enterprise?.name })}
          </p>
          <ul style={{ marginLeft: -12 }} className="mb-4">
            <li>{t('enterprise.join_or_request.desc_2_note_1')}</li>
            <li>{t('enterprise.join_or_request.desc_2_note_2')}</li>
            <li>{t('enterprise.join_or_request.desc_2_note_3')}</li>
          </ul>
          <p>
            {t('enterprise.join_or_request.desc_3', { enterpriseName: enterpriseInvitation?.enterprise?.name })}
          </p>
          {
            isAutoApprove && <p>
              {t('enterprise.join_or_request.desc_4', { enterpriseName: enterpriseInvitation?.enterprise?.name })}
            </p>
          }
          {
            ['invited', 'requested'].includes(enterpriseInvitation?.status) && <div className="mt-4">
              <Button
                type="primary"
                className="w-full"
                disabled={requested}
                loading={callingAPI || loading}
                icon={requested ? <CheckOutlined /> : <></>}
                onClick={() => joinEnterprise()}
              >
                {
                  requested ? t('enterprise.requested') : (isAutoApprove ? t('enterprise.join_or_request.join_now') : t('enterprise.join_or_request.request_to_join'))
                }
              </Button>
            </div>
          }
        </div>
      }
    </div>
  );
}

export default JoinEnterprise;